'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var About;
(function (About) {
    var MyAbout = /** @class */ (function () {
        function MyAbout(
        // private ajaxing: boolean = false,
        ) {
            var self = this;
            $('.trigOpenAbout').on('click', function () {
                var isOpen = $('.paramOpenAbout').attr('data-open');
                if (isOpen == 'false') {
                    $('.paramOpenAbout').attr('data-open', 'true');
                    $('.bulletAboutBg').fadeIn('slow');
                }
                else {
                    $('.paramOpenAbout').attr('data-open', 'false');
                    $('.bulletAboutBg').fadeOut('slow');
                }
            });
        }
        return MyAbout;
    }());
    About.MyAbout = MyAbout;
})(About || (About = {}));
exports.default = About;
